// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: JAvTJroKuQ

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicShinyButton.module.css"; // plasmic-import: JAvTJroKuQ/css

createPlasmicElementProxy;

export type PlasmicShinyButton__VariantMembers = {};
export type PlasmicShinyButton__VariantsArgs = {};
type VariantPropType = keyof PlasmicShinyButton__VariantsArgs;
export const PlasmicShinyButton__VariantProps = new Array<VariantPropType>();

export type PlasmicShinyButton__ArgsType = {};
type ArgPropType = keyof PlasmicShinyButton__ArgsType;
export const PlasmicShinyButton__ArgProps = new Array<ArgPropType>();

export type PlasmicShinyButton__OverridesType = {
  root?: p.Flex<"div">;
  buttonDefault?: p.Flex<"div">;
  signUp?: p.Flex<"div">;
};

export interface DefaultShinyButtonProps {
  className?: string;
}

const $$ = {};

function PlasmicShinyButton__RenderFunc(props: {
  variants: PlasmicShinyButton__VariantsArgs;
  args: PlasmicShinyButton__ArgsType;
  overrides: PlasmicShinyButton__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          )
        }
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"buttonDefault"}
        data-plasmic-override={overrides.buttonDefault}
        hasGap={true}
        className={classNames(projectcss.all, sty.buttonDefault)}
      >
        <div
          data-plasmic-name={"signUp"}
          data-plasmic-override={overrides.signUp}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.signUp,
            {
              [sty.signUpglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            }
          )}
        >
          {hasVariant(globalVariants, "theme", "dark")
            ? "Save + Sign Up"
            : "Save + Sign Up"}
        </div>
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "buttonDefault", "signUp"],
  buttonDefault: ["buttonDefault", "signUp"],
  signUp: ["signUp"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  buttonDefault: "div";
  signUp: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicShinyButton__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicShinyButton__VariantsArgs;
    args?: PlasmicShinyButton__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicShinyButton__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicShinyButton__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicShinyButton__ArgProps,
          internalVariantPropNames: PlasmicShinyButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicShinyButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicShinyButton";
  } else {
    func.displayName = `PlasmicShinyButton.${nodeName}`;
  }
  return func;
}

export const PlasmicShinyButton = Object.assign(
  // Top-level PlasmicShinyButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    buttonDefault: makeNodeComponent("buttonDefault"),
    signUp: makeNodeComponent("signUp"),

    // Metadata about props expected for PlasmicShinyButton
    internalVariantProps: PlasmicShinyButton__VariantProps,
    internalArgProps: PlasmicShinyButton__ArgProps
  }
);

export default PlasmicShinyButton;
/* prettier-ignore-end */
